<template>
      <div>
          <barra-navegacao :visiblebar="true" :visiblebutton="false"/>
          <div  >
            <b-card v-for="(bloco,index) in blocos" :key="index" 
                @click="listarAndares(bloco.idBloco)"              
                class="modern-nav-card">
              <div>
                <strong>{{bloco.descricao}}</strong>
              </div>
            </b-card>
          </div>
      </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },
  data(){
    return{
      blocos: [],
      andares: []
    }
  },

  created(){
    this.listarBlocos();
  },

  methods:{
    listarBlocos() {
      this.$http.get("/bloco").then((res) => {
          this.blocos = res.data.filter(b => b.status === 'A');
      });
    },
    
    listarAndares(idBloco) {
      this.$router.push("/andar/"+idBloco)
    },
  }
};
</script>

<style >

</style>
